import * as home from './home'
import * as user from './user'
export default {
  ...user,
  ...home,
}
